// @flow

import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Tabs, Tab } from '@material-ui/core/';
import TabPanel from '../../../components/tabpanel';
import Authenticate from '../../../components/download/scripts/authenticate';
import Binder from '../../../components/download/scripts/binder';
import Lists from '../../../components/download/scripts/list';
import TaxCaddy from '../../../components/download/scripts/taxcaddy';
import Lookup from '../../../components/download/scripts/lookups';
import FindAPI from '../../../components/download/scripts/findapi';
import OCR from '../../../components/download/scripts/ocr';
import { type ApiProdAuthenticationCMS } from '../../../data/cms/types/download-scripts';
import './style.css';
import GetApiproductContent from '../../../data/cms/content/apiproducts';
import NoSearchResult from '../../../components/search/noresult-search';

type Props = {
    Content: ApiProdAuthenticationCMS,
};
function Scripts(props: Props) {
    const { Content, searchValue } = props;
    const [Scriptvalue, setScriptValue] = React.useState(0);
    const [loading, setLoading] = React.useState(true);
    const [GetApiproduct, setApiproductContent] = React.useState({});
    let isSearchData = false;
    let isGetToken = false;
    let isOAuth = false;
    let isBinder = false;
    let isList = false;
    let isLooksup = false;
    let isTaxCaddy = false;
    let isOCR = false;

    React.useEffect(() => {
        const fetchContent = async () => {
            var fetchedContent = await GetApiproductContent();
            setApiproductContent(fetchedContent);
            setLoading(false);
            window.scrollTo(0, 0);
        };
        fetchContent();
    }, []);

    const scriptHhandleChange = (event, newValue) => {
        setScriptValue(newValue);
    };
    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });


    if (Object.keys(Content).length != 0) {
        isGetToken = Content.Authentication.GetToken.Title.toLowerCase().includes(searchValue.toLowerCase());
        isOAuth = Content.Authentication.OAuth.Title.toLowerCase().includes(searchValue.toLowerCase());
        isBinder = Content.Binder.Binders.Binder.filter(Content => Content.Title.toLowerCase().includes(searchValue.toLowerCase())).length > 0;
        isList = Content.List.Lists.List.filter(Content => Content.Title.toLowerCase().includes(searchValue.toLowerCase())).length > 0;
        isLooksup = Content.Lookup.Looksups.Looksup.filter(Content => Content.Title.toLowerCase().includes(searchValue.toLowerCase())).length > 0;
        isTaxCaddy = Content.TaxCaddy.TaxCaddys.TaxCaddy.filter(Content => Content.Title.toLowerCase().includes(searchValue.toLowerCase())).length > 0;
        isOCR = Content.ocr.ocrdata.Title.toLowerCase().includes(searchValue.toLowerCase());

        if (isGetToken ||
            isOAuth ||
            isBinder ||
            isList ||
            isLooksup ||
            isTaxCaddy ||
            isOCR
        ) {
            isSearchData = true;
        } else {
            isSearchData = false;
        }
    }

    return (
        <>
            <Grid item xs={12} sm={12} md={12} lg={12} className="script">
                <Typography component="div" className="script-nav">
                    <Tabs
                        value={Scriptvalue}
                        onChange={scriptHhandleChange}
                        className="script-tabs"
                        variant="scrollable"
                    >
                        <Tab label="ALL Scripts" />
                        <Tab label="Authenticate" />
                        <Tab label="Binder" />
                        <Tab label="TaxCaddy" />
                        <Tab label="Lists" />
                        <Tab label="Lookups" />
                        <Tab label="OCR" />
                    </Tabs>
                </Typography>
            </Grid>
            <TabPanel value={Scriptvalue} index={0}>
                {
                    isSearchData ?
                        <Grid
                            item
                            sm={12}
                            md={12}
                            lg={12}
                            className="apiproduct-section"
                        >
                            {!loading ? (
                                (isGetToken && isOAuth) ?
                                    <>
                                        <Grid item sm={12} md={12} lg={12} className="apiproduct-title">
                                            <Typography component="h3">authentication </Typography>
                                        </Grid>
                                        <Authenticate Content={Content.Authentication} searchValue={searchValue} />
                                    </> : ('')
                            ) : (' ')}

                            {!loading ? (
                                isBinder ?
                                    <>
                                        <Grid item sm={12} md={12} lg={12} className="apiproduct-title">
                                            <Typography component="h3">Binder </Typography>
                                        </Grid>
                                        <Binder Content={Content.Binder.Binders} searchValue={searchValue} />
                                    </> : ('')
                            ) : (' ')}

                            {!loading ? (
                                isTaxCaddy ?
                                    <>
                                        <Grid item sm={12} md={12} lg={12} className="apiproduct-title">
                                            <Typography component="h3">TaxCaddy </Typography>
                                        </Grid>
                                        <TaxCaddy Content={Content.TaxCaddy.TaxCaddys} searchValue={searchValue} />
                                    </> : ('')
                            ) : (' ')}

                            {!loading ? (
                                isList ?
                                    <>
                                        <Grid item sm={12} md={12} lg={12} className="apiproduct-title">
                                            <Typography component="h3">Lists </Typography>
                                        </Grid>
                                        <Lists Content={Content.List.Lists} searchValue={searchValue} />
                                    </> : ('')
                            ) : (' ')}

                            {!loading ? (
                                isLooksup ?
                                    <>
                                        <Grid item sm={12} md={12} lg={12} className="apiproduct-title">
                                            <Typography component="h3">Lookups </Typography>
                                        </Grid>
                                        <Lookup Content={Content.Lookup.Looksups} searchValue={searchValue} />
                                    </> : ('')
                            ) : (' ')}

                            {!loading ? (
                                isOCR ?
                                    <>
                                        <Grid item sm={12} md={12} lg={12} className="apiproduct-title">
                                            <Typography component="h3">OCR </Typography>
                                        </Grid>
                                        <OCR Content={Content.ocr} searchValue={searchValue} />
                                    </> : ('')
                            ) : (' ')}


                        </Grid>
                        :
                        <Grid container className="nosearch">
                            <NoSearchResult />
                        </Grid>
                }

            </TabPanel>
            <TabPanel value={Scriptvalue} index={1}>
                <Authenticate Content={Content.Authentication} searchValue={searchValue} />
            </TabPanel>
            <TabPanel value={Scriptvalue} index={2}>
                <Binder Content={Content.Binder.Binders} searchValue={searchValue} />
            </TabPanel>
            <TabPanel value={Scriptvalue} index={3}>
                <TaxCaddy Content={Content.TaxCaddy.TaxCaddys} searchValue={searchValue} />
            </TabPanel>
            <TabPanel value={Scriptvalue} index={4}>
                <Lists Content={Content.List.Lists} searchValue={searchValue} />
            </TabPanel>
            <TabPanel value={Scriptvalue} index={5}>
                <Lookup Content={Content.Lookup.Looksups} searchValue={searchValue} />
            </TabPanel>
            <TabPanel value={Scriptvalue} index={6}>
                <OCR Content={Content.ocr} searchValue={searchValue} />
            </TabPanel>
            <FindAPI Content={Content.Find} />
        </>
    );
}
Scripts.propTypes = {
    Content: PropTypes.object,
};
export default Scripts;
